'use strict';

var _ = require('lodash');
var ChartFaresLegendDirective = function ChartFaresLegendDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-fares-legend.html'),
    controller: 'ChartFaresLegendController',
    scope: {
      // reset
      resetChartHandler: '=',
      // legend
      legend: '=',
      // markets
      marketItems: '=',
      selectedMarket: '=',
      marketChangeHandler: '=',
      noRaDataMarkets: '=',
      gridModalId: '@'
    },
    link: function link($scope) {
      $scope.$watch('selectedMarket', function (current) {
        $scope.isNoRaDataMarketSelected = _.includes($scope.noRaDataMarkets, current);
        if (current !== undefined) {
          $scope.marketChangeHandler($scope.selectedMarket);
        }
      });
      $scope.localMarketChangeHandler = function () {
        $scope.marketChangeHandler($scope.selectedMarket);
      };
    }
  };
};
ChartFaresLegendDirective.$inject = [];
module.exports = ChartFaresLegendDirective;